import { Directive, HostListener, Optional, Self } from "@angular/core";
import { Dropdown } from "primeng/dropdown";
import { MultiSelect } from "primeng/multiselect";

@Directive({
    selector: "p-multiSelect, p-dropdown"
})
export class NoFilterAutofocusSmDirective {
    private el: { autofocusFilter: boolean };
    private originalAutofocus: boolean;

    constructor(@Optional() @Self() multiselect: MultiSelect, @Optional() @Self() dropdown: Dropdown) {
        this.el = multiselect ?? dropdown;
        this.originalAutofocus = this.el?.autofocusFilter;

        this.refreshAutofocus();
    }

    private refreshAutofocus() {
        if (!this.el) {
            return;
        }

        if (window.innerWidth < 576) {
            this.el.autofocusFilter = false;
        } else {
            this.el.autofocusFilter = this.originalAutofocus;
        }
    }

    @HostListener("window:resize")
    onWindowResize() {
        this.refreshAutofocus();
    }
}
